<!--
  A 24-hour time box ("16:30"), the same on every browser. Typing 1630, 16.30 or 9 works too:
  it's tidied to HH:MM when you leave the box.
-->
<script lang="ts">
  let { value = $bindable(""), label = "Time", id }: { value?: string; label?: string; id?: string } = $props();

  export function tidy(raw: string): string | null {
    const t = raw.trim().replace(/[.h]/g, ":");
    const m = /^(\d{1,2})(?::?(\d{2}))?$/.exec(t);
    if (!m) return null;
    const h = Number(m[1]);
    const min = Number(m[2] ?? 0);
    if (h > 23 || min > 59) return null;
    return `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
  }
  let text = $state(value);
  $effect(() => {
    text = value;
  });
  let bad = $state(false);
</script>

<input
  class="input time"
  class:bad
  {id}
  type="text"
  inputmode="numeric"
  autocomplete="off"
  placeholder="16:00"
  maxlength="5"
  aria-label={label}
  aria-invalid={bad}
  bind:value={text}
  oninput={() => {
    if (/^\d{2}:\d{2}$/.test(text) && tidy(text)) value = text;
  }}
  onblur={() => {
    const t = tidy(text);
    bad = t === null && text.trim() !== "";
    if (t) value = text = t;
  }}
/>

<style>
  .time {
    font-variant-numeric: tabular-nums;
  }

  .bad {
    box-shadow: inset 0 0 0 2px var(--danger, #c0392b);
  }
</style>
